import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const advertiserStaticData = {
  menuTitle: MenuTitle.Advertiser
};
export const Route = createFileRoute('/_private-routes/advertiser')({
  staticData: advertiserStaticData
});
